(function ($, Drupal) {
  Drupal.behaviors.heimatLightbox = {
    attach: function (context, settings) {
      const lightbox = GLightbox({
        'selector': '.lightbox'
      });
    }
  }
})(jQuery, Drupal);
